import { TableBody } from 'components/Table/TableBody/TableBody';
import { ReportsTableItem } from 'utils/models';
import { queryKeys } from 'utils/query';
import { ReportsOverviewColumns } from 'components/Table/Columns/ReportsOverviewColumns';
import { getReportsOverview } from 'services/reports';
import { Anchor } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { TableConfig } from 'models/general';
import { useNavigate, useParams } from 'react-router-dom';
import { PatientDetailsTabs } from 'pages/Main/Patients/Patients.helpers';
import { useShowRestricted } from 'hooks/useShowRestricted';
import { PaperHeader } from 'components/PaperHeader/PaperHeader';

const reportsOverviewListConfig: TableConfig = {
  queryKey: queryKeys.reportsOverview,
};

export const ReportsOverviewList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { patientId } = useParams<{ patientId: string }>();
  const { filter } = useShowRestricted();

  return (
    <TableBody<ReportsTableItem>
      getData={getReportsOverview}
      getColumns={ReportsOverviewColumns}
      config={reportsOverviewListConfig}
      titleBar={
        <PaperHeader titleKey={'patients_reports_title'}>
          <Anchor
            c={'var(--mantine-color-turquoise-7)'}
            onClick={() => navigate(`/patients/${patientId}/details/${PatientDetailsTabs.Reports}${filter}`)}
          >
            {t('patients_reports_seemore')}
          </Anchor>
        </PaperHeader>
      }
      limit={3}
      loadToInfinity={false}
      saveFiltersForLater={false}
    />
  );
};
